import { useAuth } from '@/hooks/useAuth';
import { useImpersonateStore } from '@/stores/useImpersonateStore';

export function useEffectiveUser() {
  const { user } = useAuth();
  const { impersonatedUserId, impersonatedUserName, isImpersonating } = useImpersonateStore();

  return {
    effectiveUserId: isImpersonating ? impersonatedUserId : user?.id ?? null,
    effectiveUserName: isImpersonating ? impersonatedUserName : null,
    isImpersonating,
    realUser: user,
  };
}
